import React from 'react';
import { Box, Button, Typography, Card, CardContent, Grid } from '@mui/material';

import welcomeImg from 'src/assets/images/image_28455.png';

const WelcomeCard = () => {
  return (
    <Card elevation={0} sx={{ backgroundColor: (theme) => theme.palette.primary.light, py: 0 }}>
      <CardContent sx={{ py: 2 }}>
        <Grid container spacing={3} justifyContent="space-between">
          <Grid item sm={6} display="flex" alignItems="center">
            <Box
              sx={{
                textAlign: {
                  xs: 'center',
                  sm: 'left',
                },
              }}
            >
              <Typography variant="h5">배너 광고 부분</Typography>
              <Typography variant="subtitle2" my={2} color="textSecondary">
                성신한방병원 환자 통합예약 시스템 OPEN
              </Typography>
              <Button variant="contained" color="primary">
                Check
              </Button>
            </Box>
          </Grid>
          <Grid item sm={5}>
            <Box>
              <img src={welcomeImg} alt={welcomeImg} width={'350px'} />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default WelcomeCard;
